import { render, staticRenderFns } from "./ConfigTimeWindowFeature.vue?vue&type=template&id=2f8bb058&"
import script from "./ConfigTimeWindowFeature.vue?vue&type=script&lang=js&"
export * from "./ConfigTimeWindowFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports